<div class="legal-entity-list-wrapper">
  <app-toolbar
    [statusDescriptions]="bcrStatuses"
    [currentStatusDescription]="selectedStatusDescription"
    [showStatusDropdown]="showStatusDropdown"
  />
  <section class="feature-shell">
    <div class="list-layout">
      <div class="list-panel overlay-scroll--custom" scrollActivity [scrollActivityCustom]="true">
        <div class="search-row">
          <app-az-searchbar
            [search]="true"
            [value]="searchText()"
            (valueChange)="onSearchChange($event)"
            [datePicker]="false"
          />
        </div>
        <!-- <div class="toggle-row historical-switch">
          <app-switch
            [checked]="historicalMode()"
            (changed)="historicalMode.set($event)"
            ariaLabel="Historical Search"
            label="HISTORICAL SEARCH"
            size="sm"
          ></app-switch>
        </div> -->
        <!-- Loader & error states -->
        <div class="status-row" *ngIf="loadError()" aria-live="polite">
          <div *ngIf="loadError()" class="error-container" role="alert">
            {{ loadError() }}
          </div>
        </div>
        <div
          *ngIf="loading()"
          class="loading-overlay"
          aria-live="polite"
          aria-label="Loading legal entities"
        >
          <div class="overlay-content">
            <app-spinner [display]="true" [diameter]="48" aria-label="Loading"></app-spinner>
            <span>Loading legal entities…</span>
          </div>
        </div>
        <div class="entity-groups">
          <ng-container *ngFor="let group of displayGroups(); trackBy: trackByCountry">
            <app-accordion-panel
              [title]="group.country"
              [panelId]="'panel-' + group.country"
              [expanded]="isExpanded(group.country)"
              [items]="group.legal_entities"
              [activeId]="activeId()"
              (itemSelect)="select($event)"
              (panelToggled)="toggleCountry(group.country)"
            ></app-accordion-panel>
          </ng-container>
        </div>
      </div>
      <div
        class="detail-panel overlay-scroll--custom"
        scrollActivity
        [scrollActivityCustom]="true"
        *ngIf="activeId() as selectedId"
      >
        <app-legal-entity-detail [entityId]="selectedId" />
      </div>
    </div>
  </section>
</div>
